export class DatosCita {
    idCita;
    idListaEspera;
    idPaciente;
    idPacientePadre;
    nombrePaciente;
    idTagMotivoCita;
    fechaCita;
    idDoctor;
    idEspecialidad;
    sillon;
    horaInicio;
    horaFin;
    comentario;
    idSexo;
    correo;
    celular;

    citaEmbajador;
    esPacienteNuevo;
    citaAdministrativa;

    tratamientos;
    ptiActivo;

    confianza;
    ultimoTratamiento;
    fechaNacimientoCompleta;
    tipoPaciente;
    tagMotivoCita;
    doctor;
    especialidad;
    duracionCita;

    citaReagendar;
    citaDesdeCal;
    idCanalOrigen;

    citaEdicion;

    constructor() {
        this.idCanalOrigen = 1;
        this.citaEmbajador = false;
        this.esPacienteNuevo = true;
        this.citaAdministrativa = false;

        // this.fechaCita = new Date();

        this.tratamientos = Array();

        this.duracionCita = 0;

        this.citaEdicion = false;
        this.citaReagendar = false;
    }
}